'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MomentUtilities = undefined;

var _DateTimeFormats = require('./DateTimeFormats');

var moment = require('moment');

// eslint-disable-next-line max-params
function getDifference(startDate, endDate, format, units) {
    var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;
    var start = moment(startDate, dateFormat);
    var end = moment(endDate, dateFormat);
    return end.diff(start, units);
}

function leftPadTime(strTime) {
    var expectedDigitLength = 2;
    var radix = 10;
    var tenHours = 10;
    var hours = strTime.slice(0, strTime.indexOf(':'));
    if (hours.length < expectedDigitLength && parseInt(hours, radix) < tenHours) {
        return '0' + strTime;
    }
    return strTime;
}

var MomentUtilities = exports.MomentUtilities = {
    convertStringToMoment: function convertStringToMoment(dateTimeString, format) {
        var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;
        return moment(dateTimeString, dateFormat);
    },
    addMinutes: function addMinutes(strDate, minutes, format) {
        var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;
        var date = moment(strDate, dateFormat, true);
        return date.add(minutes, 'minutes').format(format);
    },
    isDate: function isDate(strDate, format) {
        var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;

        var date = moment(strDate, dateFormat, true);
        return date.isValid();
    },
    isTime: function isTime(strTime, format) {
        var timeFormat = format || _DateTimeFormats.DateTimeFormats.TIME;
        var timeValue = strTime !== null ? leftPadTime(strTime) : null;
        var time = moment(timeValue, timeFormat, true);
        return time.isValid();
    },
    hoursDifference: function hoursDifference(startDate, endDate, format) {
        return getDifference(startDate, endDate, format, 'hours');
    },
    minutesDifference: function minutesDifference(startDate, endDate, format) {
        var dateTimeFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;
        return getDifference(startDate, endDate, dateTimeFormat, 'minutes');
    },
    daysDifference: function daysDifference(startDate, endDate, format) {
        var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;

        var start = moment(startDate, dateFormat).startOf('day');
        var end = moment(endDate, dateFormat).startOf('day');
        var daysDiff = end.diff(start, 'days');

        return daysDiff;
    },


    // eslint-disable-next-line max-params, complexity
    dateIsBetween: function dateIsBetween(date, startDate, endDate, format) {
        var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;

        var mDate = MomentUtilities.convertStringToMoment(date, dateFormat);
        var mStartDate = MomentUtilities.convertStringToMoment(startDate, dateFormat);
        var mEndDate = MomentUtilities.convertStringToMoment(endDate, dateFormat);

        return mDate.isBetween(mStartDate, mEndDate) || mDate.isSame(mStartDate) || mDate.isSame(mEndDate);
    },
    datesAreEqual: function datesAreEqual(date, compareDate, format) {
        var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;

        var mDate = MomentUtilities.convertStringToMoment(date, dateFormat);
        var mCompareDate = MomentUtilities.convertStringToMoment(compareDate, dateFormat);

        return mDate.isSame(mCompareDate);
    },
    dateIsAfter: function dateIsAfter(date, compareDate, format) {
        var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;

        var mDate = MomentUtilities.convertStringToMoment(date, dateFormat);
        var mCompareDate = MomentUtilities.convertStringToMoment(compareDate, dateFormat);

        return mDate.isAfter(mCompareDate);
    },
    dateIsAfterOrEqual: function dateIsAfterOrEqual(date, compareDate, format) {
        return MomentUtilities.dateIsAfter(date, compareDate, format) || MomentUtilities.datesAreEqual(date, compareDate, format);
    },
    dateIsBefore: function dateIsBefore(date, compareDate, format) {
        var dateFormat = format || _DateTimeFormats.DateTimeFormats.DATETIME;

        var mDate = MomentUtilities.convertStringToMoment(date, dateFormat);
        var mCompareDate = MomentUtilities.convertStringToMoment(compareDate, dateFormat);

        return mDate.isBefore(mCompareDate);
    },
    dateIsBeforeOrEqual: function dateIsBeforeOrEqual(date, compareDate, format) {
        return MomentUtilities.dateIsBefore(date, compareDate, format) || MomentUtilities.datesAreEqual(date, compareDate, format);
    }
};